module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEABAMAAACuXLVVAAAAG1BMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAKkTAO0UW9jFsMAAAAB3RSTlMADQ4PEBESsu+mmQAAAP5JREFUeF7swAENAAAAwiD7p7bHBwsCAAAAAAAAAAAAAHg7d4yCMAyGYRinHsHVzdWjeBQRMb1Bc2zn9BdBKB9Fn3fNkAe6pPlLpzZ0SwMOcx9a0oJjX7WEAfPuAD37DKZeAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAInRWBhQR2PXLKCOxp5hQB2NZQCfdvlNAAAAAAAAAAAAAAAAAAAAQBu6pQGH1oeWSxZQL4IeYUC9CMoAPu3ymwAAAAAAAIA2FAbUY087hQHntfceBtRjTxjwBvxnAAAAAAAAAAAAAAAAAACA+nq+/dK+AVP5e8/mS19+pL390r6TJEmSXlI40+NHSMKIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/signal-4.png
// module id = 1165
// module chunks = 0